import z from 'zod';

export const HandoffReferencesSchema = z.object({
  topics: z.record(z.string(), z.boolean()),
  flowSteps: z.record(z.string(), z.boolean()),
});
